import React from "react";
import DetailPanel from './detailPanel';

import './basicListPanel.scss';

export default class BasicListPanel extends React.Component {
    static defaultProps = {
        columns: 2,
        index: -1,
        detail: null,
    }
    constructor(props) {
        super(props);
        this.state = {
            openDetailIndex: -1,
            prevIndex: -1
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.index != -1) {
            const curRows = nextProps.index == -1 ? -1 : parseInt(nextProps.index / nextProps.columns);
            const prevRows = prevState.prevIndex == -1 ? -1 : parseInt(prevState.prevIndex / nextProps.columns);
            const openDetailIndex = curRows != prevRows ? (prevState.openDetailIndex + 1) % 2 : prevState.openDetailIndex;
            return { openDetailIndex, prevIndex: nextProps.index };
        } else {
            return { openDetailIndex: -1, prevIndex: -1 };
        }
    }

    render() {
        const { index, columns, detail, children, ...other } = this.props;
        const { openDetailIndex } = this.state;
        const rows = children && children.length > 0 ? this.renderRows(columns, children) : null;
        const detailPanel1 = this.renderDetail(openDetailIndex == 0 ? index : -1, columns, openDetailIndex == 0 ? detail : null, openDetailIndex == 0);
        const detailPanel2 = this.renderDetail(openDetailIndex == 1 ? index : -1, columns, openDetailIndex == 1 ? detail : null, openDetailIndex == 1);

        return (
            <div {...other} className='pubhub-list-panel'>
                {rows}
                {detailPanel1}
                {detailPanel2}
            </div>
        );
    }

    renderRows(columns, children) {
        const rows = parseInt((children.length + columns - 1) / columns);
        const cellBoxClassName = this.buildItemBoxClassName(columns);
        const list = [];
        for (let i = 0; i < rows; i++) {
            const begin = i * columns;
            const end = Math.min(children.length, begin + columns);
            list.push(this.renderRow(cellBoxClassName, children.slice(begin, end), i));
        }

        return list;
    }

    renderRow(cellBoxClassName, children, index) {
        const cells = children.map((child, idx) => this.renderItem(cellBoxClassName, child, idx));
        const style = { order: index };
        return (
            <div key={index} style={style} className='container'>
                <div className='row'>
                    {cells}
                </div>
            </div>
        );
    }

    renderItem(cellBoxClassName, child, key) {
        return (
            <div key={key} className={cellBoxClassName}>
                {child}
            </div>
        );
    }

    buildItemBoxClassName(columns) {
        switch (columns) {
            case 6: return 'item-box col col-2';
            case 5: return 'item-box col col-3';
            case 4: return 'item-box col col-3';
            case 3: return 'item-box col col-4';
            case 2: return 'item-box col col-6';
            default: return 'item-box col col-12';
        }
    }

    renderDetail(index, columns, detail, open) {
        return (
            <DetailPanel index={index} columns={columns} open={open}>
                {detail}
            </DetailPanel>
        );
    }
}